var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomFormula(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#222822"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1994 19L11.4994 12.72L9.73938 14.9V19H6.85938V5H9.73938V11.18L14.3794 5H17.7394L13.3794 10.4L18.3994 19H15.1994Z",
    fill: "#1EED9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFormula);
export default __webpack_public_path__ + "static/media/customFormula.1a03ffbb3b0cb4e2fe76146386860b1b.svg";
export { ForwardRef as ReactComponent };